import revive_payload_client_4sVQNw7RlN from "/home/runner/work/coassemble-author/coassemble-author/frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/coassemble-author/coassemble-author/frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/coassemble-author/coassemble-author/frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/home/runner/work/coassemble-author/coassemble-author/frontend/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/runner/work/coassemble-author/coassemble-author/frontend/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/coassemble-author/coassemble-author/frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/home/runner/work/coassemble-author/coassemble-author/frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/coassemble-author/coassemble-author/frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_VdOeuw25Mb from "/home/runner/work/coassemble-author/coassemble-author/frontend/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/home/runner/work/coassemble-author/coassemble-author/frontend/.nuxt/sentry-client-config.mjs";
import access_IJns4yiU91 from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/services/access.js";
import analytics_kgnNkpJZfi from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/plugins/analytics.js";
import bus_izp2IIOARA from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/services/bus.js";
import confetti_PqLRek5P3E from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/services/confetti.js";
import datetime_Md2pBu7vZW from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/services/datetime.js";
import http_k4H9g2UIum from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/plugins/http.js";
import password_6thtPRIFfW from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/services/password.js";
import scroll_UJbdxsl552 from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/services/scroll.js";
import timeout_1JS8OcQPLY from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/services/timeout.js";
import translator_2ZNexwrPCM from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/plugins/translator.js";
import window_D6ACFcB6Vg from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/services/window.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  navigation_repaint_client_bs2bWDGRIE,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  access_IJns4yiU91,
  analytics_kgnNkpJZfi,
  bus_izp2IIOARA,
  confetti_PqLRek5P3E,
  datetime_Md2pBu7vZW,
  http_k4H9g2UIum,
  password_6thtPRIFfW,
  scroll_UJbdxsl552,
  timeout_1JS8OcQPLY,
  translator_2ZNexwrPCM,
  window_D6ACFcB6Vg
]